import FormField from "./formField";

export const SEATED_FORM_ID = 1;

export default class Form {
	constructor({ id, name, event, rates, formFields } = {}) {
		this.id = id;
		this.name = name;
		this.event = event;
		this.rates = rates || [];
		this.formFields = formFields || [];
	}
	static buildFromJSON(json) {
		return new Form({
			id: json.id ?? parseInt(json.id_form),
			name: json.name ?? "",
			event: json.event ?? "",
			rates: json.rates ?? [],
			formFields: json.form_fields?.map(FormField.buildFromJSON) ?? []
		});
	}

	toJSON() {
		return {
			id_form: this.id,
			name: this.name,
			event: this.event,
			rates: this.rates,
			form_fields: this.formFields
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getEvent() {
		return this.event;
	}

	getRates() {
		return this.rates;
	}

	getFormFields() {
		return this.formFields;
	}

	getFormFieldById(id) {
		return this.formFields.find(field => field.getId() === id);
	}
}
